<script setup>
import {useModalStore} from "../../../store/modal";
import {useTicketStore} from "../../../store/tickets";
import DefaultModalBase from "../DefaultModalBase.vue";
import {onMounted, ref} from "vue";
import {useCallStore} from "../../../store/calls.js";

const loading = ref(false)
const callStore = useCallStore()
const modalStore = useModalStore()
const is_complete = ref(false)

const completeCall = async () => {
    loading.value = true
    await callStore.completeCall(modalStore.props.id)
    loading.value = false
    is_complete.value = true
}

onMounted(async () => {
    loading.value = true
    await callStore.getCall(modalStore.props.id)
    loading.value = false
    if (callStore.call.completed_at) {
        is_complete.value = true
    }
})
</script>

<template>
    <DefaultModalBase :heading="!is_complete ? 'Are you sure you want to close this call?' : 'Call completed.'" icon="check-all" :loading :refresh="is_complete">

        <div class="complete-ticket-actions">
            <brand-button @click="completeCall()" v-if="!is_complete">Yes, mark as complete</brand-button>
            <brand-button variant="secondary" @click="modalStore.close(is_complete)">{{ !is_complete ? "Nevermind" : "Done" }}</brand-button>
        </div>
    </DefaultModalBase>
</template>

<style scoped lang="scss">
.complete-ticket-actions {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}
</style>
